import { json, type LoaderFunctionArgs } from '@remix-run/node';
import type { ShouldRevalidateFunction } from '@remix-run/react';
import { z } from 'zod';
import { getConversationMessage } from '~/modules/chat/api/get-conversation-message.server';

export const CONVERSATION_MESSAGE_API = '/remix-api/chat/message';

const QUERY_SCHEMA = z.object({
    id: z.coerce.number().int().positive(),
});

/**
 * API endpoint to get a conversation message.
 * Use with the `useConversation` hook.
 * @see {@link packages/web/app/modules/chat/hooks/use-conversation.ts}
 */
export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    const { logger } = context;
    const url = new URL(request.url);
    const result = QUERY_SCHEMA.safeParse({
        id: url.searchParams.get('id'),
    });
    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const message = await getConversationMessage({
            context,
            id: result.data.id,
        });

        if (!message) {
            return json(null, { status: 500 });
        }

        return json({ message });
    } catch (error) {
        logger.error(`Error in ${CONVERSATION_MESSAGE_API}`, { error });
        return json(null, { status: 500 });
    }
};

export const shouldRevalidate: ShouldRevalidateFunction = () => {
    return false;
};
